export const regionIsoEnum = Object.freeze({
    GERMANY: 'de',
    AUSTRIA: 'at',
    AUSTRALIA: 'au',
    UNITED_KINGDOM: 'uk',
    ITALY: 'it',
});
